import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hashtag14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.9932 1.60136C11.0492 1.19095 10.7618 0.812872 10.3514 0.756906C9.94101 0.70094 9.56293 0.988278 9.50697 1.39869L9.18633 3.75H5.70022L5.99321 1.60136C6.04918 1.19095 5.76184 0.812872 5.35142 0.756906C4.94101 0.70094 4.56293 0.988278 4.50697 1.39869L4.18633 3.75H2.25C1.83579 3.75 1.5 4.08579 1.5 4.5C1.5 4.91421 1.83579 5.25 2.25 5.25H3.98179L3.50452 8.75H1.75C1.33579 8.75 1 9.08579 1 9.5C1 9.91421 1.33579 10.25 1.75 10.25H3.29997L3.00697 12.3987C2.951 12.8091 3.23834 13.1872 3.64875 13.2432C4.05917 13.2991 4.43725 13.0118 4.49321 12.6014L4.81385 10.25H8.29997L8.00697 12.3987C7.951 12.8091 8.23834 13.1872 8.64875 13.2432C9.05917 13.2991 9.43725 13.0118 9.49321 12.6014L9.81385 10.25H11.75C12.1642 10.25 12.5 9.91421 12.5 9.5C12.5 9.08579 12.1642 8.75 11.75 8.75H10.0184L10.4957 5.25H12.25C12.6642 5.25 13 4.91421 13 4.5C13 4.08579 12.6642 3.75 12.25 3.75H10.7002L10.9932 1.60136ZM8.50452 8.75L8.98179 5.25H5.49567L5.0184 8.75H8.50452Z'
      fill='currentColor'
    />
  </Svg>
);

Hashtag14.displayName = 'Hashtag14';
export default Hashtag14;
